export const VIEWER = {
  viewer: {
    loadingMessage: 'Loading PDF...',
    closeFile: 'Close file',
    errors: {
      invalidFileType: 'Please select a valid PDF file.',
      loadingFail: 'Failed to load PDF file.',
      noFileSelected: 'No PDF file specified.',
    },
    constrols: {
      previous: 'Previous page',
      next: 'Next page',
      currentOfAll: '{{currentPage}} of {{numPages}}',
    },
  },
}
